import { HashLink as Link } from "react-router-hash-link";

function Logo() {
    return (
        <Link to="/#" className="logo">
          Z
        </Link>
    )
}

export default Logo
